import { internalApi } from '../../common/axios';
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";

const fetchCountryData = async () => {
    const { data } = await internalApi.get("country");
    data.countryInfo.push({
        countryCode: "CN",
        langCode: "zh-Hans",
        countryName: "중국",
        languageName: "중국어(간체)"
    })
    return data.countryInfo;
};

export const useCountryData = () => {
    return useQueryBase('countryData', fetchCountryData);
};

const updateCountryData = async (countryData) => {
    await internalApi.post('country', countryData);
    return countryData;
};

export const useUpdateCountryData = () => {
    return useMutationBase('countryData', updateCountryData);
}